// extracted by mini-css-extract-plugin
module.exports = {"method":"_2i-81","method-text":"_16WXH","methodText":"_16WXH","get":"_149fM","post":"_3VS_A","delete":"_8hCyf","put":"_1MTPj","patch":"_36nLN","head":"_3wVe_","options":"A11if"};